module.exports = __webpack_public_path__ + "static/img/Advanced-Torso-CT.f0059fc4.png";